<template>
  <a-layout class="full-window">
    <a-layout-header class="header-wrapper">
      <div class="header-container">
        <div class="header-left">
          <Logo :show_admin="false" @click="() => $router.push('/')" />
        </div>
        <div class="header-middle"></div>
        <div class="header-right">
          <a-space direction="horizontal">
            <a-button type="text">
              <router-link to="/product">PRODUCT</router-link>
            </a-button>
            <a-button type="text">
              <router-link to="/pricing">PRICING</router-link>
            </a-button>
            <a-button type="text">
              <router-link to="/docs">DOCS</router-link>
            </a-button>
            <a-button type="text">
              <router-link to="/blog">BLOG</router-link>
            </a-button>
            <a-button type="text">
              <router-link to="/login">SIGN IN</router-link>
            </a-button>
            <a-button type="primary">
              <router-link to="/signup">GET STARTED</router-link>
            </a-button>
          </a-space>
        </div>
      </div>
    </a-layout-header>
    <a-layout-content>
      <div class="main-content">
        <slot></slot>
      </div>
      <a-row>
        <foot-notes class="foot-notes"> </foot-notes>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts" setup>
import Logo from '@/components/core/company-logo.vue'
import FootNotes from '@/components/core/foot-notes.vue'
defineOptions({
  name: 'PublicLayout',
  displayName: 'PublicLayout',
})
</script>
<style scoped lang="scss">
.header-wrapper {
  justify-content: center;
  height: 74px;
}
@mixin container-styles {
  position: relative;
  z-index: 1;
  right: 0px;
  padding-left: 0 !important;
  min-width: 1152px;
  max-width: 1152px;
  display: inline-flex;
  height: 74px;
}

@mixin responsive-container {
  min-width: 100%;
  max-width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

/* Use mixins */
.header-container {
  @include container-styles;
}

@media (max-width: 1152px) {
  .header-container {
    @include responsive-container;
  }
}

@media (max-width: 768px) {
  .header-container {
    @include responsive-container;
    height: auto;
    display: block;
  }
}

.header-container::v-deep(a) {
  font-weight: bold;
}
.header-container::v-deep(a:hover) {
  color: unset;
}
.header-left {
  width: 175px;
}
.header-middle {
  width: 100%;
}
.header-right {
  display: inline-flex;
  position: relative;
  right: 0;
  padding: 20px;
}
.main-content {
  display: flex;
  justify-content: center;
  overflow: scroll;
  width: 100%;
  min-height: calc(100% - var(--footer-height));
}
#footer-content {
  height: 20px;
}
.foot-notes {
  justify-content: center;
  margin-bottom: 10px;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
